import BasicHeader from "@components/BasicLayout/BasicHeader";
import BasicRouter, { dailyRoute, homeRoute, hourlyRoute, sunMoonRoute } from "@/router";
import React, { useRef } from "react";
import { setSearchParams, getSearchParam, getParamType, isTestLink } from "@/utils";
import { SafeArea } from "antd-mobile";
import PrivacyAgreement from "./PrivacyAgreement";
import { useLocation } from "react-router-dom";
import lodash from "lodash";
export const onResizeObserver = (callback: (arg0: ResizeObserverEntry[]) => any) => {
  return new ResizeObserver(_entries => {
    callback && callback(_entries);
  });
};

export function changeUrlParams(paramKey = "_t", expires = 1000 * 60 * 3) {
  return new Promise(resolve => {
    const paramValue: any = getSearchParam(paramKey);
    if (paramValue && Date.now() - paramValue > expires) {
      if (getParamType(paramKey, window.location.href) === "search") {
        setSearchParams(paramKey, Date.now());
        resolve(getSearchParam(paramKey));
      }
    }
    if (!paramValue) {
      setSearchParams(paramKey, Date.now());
      resolve(getSearchParam(paramKey));
    }
  });
}

const BasicLayout: React.FC = () => {
  const basicMainRef = useRef<HTMLDivElement | null>(null);
  const { pathname } = useLocation();
  const adIndex =
    pathname === hourlyRoute.path ? 1 : pathname === dailyRoute.path ? 3 : pathname === sunMoonRoute.path ? 8 : "";

  const isWiOrWgDomain = [...domainMap["wi"], ...domainMap["wg"]].includes(window.location.hostname);
  const isOtherDomain = lodash
    .flatten(Object.values(lodash.omit(domainMap, ["wi"])))
    .includes(window.location.hostname);

  return (
    <>
      <SafeArea position="top" />
      <BasicHeader />
      <div id="basic-main" ref={basicMainRef}>
        <BasicRouter />
        {(isTestLink(domains) || (pathname !== homeRoute.path && !isEmptyType(adIndex) && isWiOrWgDomain)) && (
          <GoogleAd {...useGoogleAd("320x100", adIndex)} />
        )}
        {(isTestLink(domains) || (pathname !== homeRoute.path && isOtherDomain)) && (
          <GoogleAd {...useGoogleAd("300x250", 3)} />
        )}
        <PrivacyAgreement />
      </div>
      <SafeArea position="bottom" />
    </>
  );
};

export default BasicLayout;
